import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IEventsResponseBody, IGetEventsParams } from './types';

export const getEvents = async (params?: IGetEventsParams): Promise<IEventsResponseBody> => {
  try {
    const url = new URL(`${API_URL}/events`);

    if (params?.entity_type) {
      url.searchParams.append('entity_type', params.entity_type);
    }
    if (params?.entity_id) {
      url.searchParams.append('entity_id', params.entity_id);
    }
    if (params?.event_type) {
      url.searchParams.append('event_type', params.event_type);
    }
    if (params?.status) {
      url.searchParams.append('status', params.status);
    }

    const res = await fetch(url.href);

    if (!res.ok) throw new Error();

    return await res.json();
  } catch (e) {
    throw new Error(`Could not fetch events: ${e.message}`);
  }
};
